import React from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

interface VehicleInspectionReservationConfirmBottomSheetData {
  name: string;
  date: string;
  time: string;
}

function VehicleInspectionReservationConfirmBottomSheet() {
  const {t} = useInferableTranslation();
  const {name, date, time} = (window as any).data as VehicleInspectionReservationConfirmBottomSheetData;

  return (
    <div className="bottom_sheet bottom_sheet_reservation">
      <div className="bottom_sheet_header">
        <h2 className="bottom_sheet_title">{t('T10334')}</h2>
        <button
          type="button"
          className="btn btn_ic"
          aria-label={t('T10017')}
          onClick={() => window.bottomSheetClose(false)}
        >
          <span
            className="ic ic_close_20px"
            aria-hidden="true"
          />
        </button>
      </div>
      <div className="bottom_sheet_inner">
        <div className="bottom_sheet_contents">
          <div className="bottom_sheet_container">
            <dl className="vehicle_info align_left">
              <div className="vehicle_item">
                <dt className="info_title">{t('T10335')}</dt>
                <dd className="info_text">{name}</dd>
              </div>
              <div className="vehicle_item">
                <dt className="info_title">{t('T10275')}</dt>
                <dd className="info_text">{date}</dd>
              </div>
              <div className="vehicle_item">
                <dt className="info_title">{t('T10054')}</dt>
                <dd className="info_text">{time}</dd>
              </div>
            </dl>
          </div>
        </div>
        <div className="bottom_sheet_footer bottom_sheet_footer_complex">
          <button
            type="button"
            className="btn btn_large btn_outline"
            onClick={() => window.bottomSheetClose(false)}
          >
            {t('T10316')}
          </button>
          <button
            type="button"
            className="btn btn_large btn_filled"
            onClick={() => window.bottomSheetClose(true)}
          >
            {t('T10114')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default VehicleInspectionReservationConfirmBottomSheet;
